import { useState, useEffect } from 'react';
import { fetchCardList, getPackageDrop } from './ipdService';

function useDropDownHook() {
    const [cardDropVal, setCardDropValState] = useState([]);
    const [packageDropValState, setPackageDropValState]= useState([]);


    const fetchCard = async () => {
        try {
            let result = await fetchCardList();
            if (result.status === 200) setCardDropValState(result?.data?.result);
        } catch (e) {
            return e
        }

    }
    
  
    const fetchPackage = async () => {
        try {
            let result = await getPackageDrop();
            if (result.status === 200) setPackageDropValState(result?.data?.result);
        } catch (e) {
            return e
        }

    }
    useEffect(() => {
        fetchCard();
        fetchPackage();
    }, []);
   
    return {
        cardDropVal,
        packageDropValState


    };
}

export default useDropDownHook;
